import { ChevronLeft, ChevronRight } from '@carbon/icons-react';
import React, { Dispatch, SetStateAction } from 'react';

import { Batch } from './BatchRunModels';
import { Breadcrumb } from 'react-bootstrap';
import styles from './SourceSystemDetails.module.css';

interface BatchRunBreadCrumbProps {
    setSelectedSourceSystemKey: Dispatch<SetStateAction<number | null>>;
    setSelectedBatchRun: Dispatch<SetStateAction<Batch | undefined>>;
    sourceSystemName?: string;
    batchName?: string;
}

const BatchRunBreadCrumb: React.FC<BatchRunBreadCrumbProps> = ({
    setSelectedSourceSystemKey,
    setSelectedBatchRun,
    sourceSystemName,
    batchName,
}) => {
    return (
        <div className="flex-row">
            {!!sourceSystemName && (
                <button
                    className={styles.backButton}
                    onClick={() => {
                        if (batchName) {
                            setSelectedBatchRun(undefined);
                        } else if (sourceSystemName) {
                            setSelectedSourceSystemKey(null);
                        }
                    }}
                >
                    <ChevronLeft size={24} />
                    <span className="ml-2">Back</span>
                </button>
            )}
            <Breadcrumb>
                <Breadcrumb.Item
                    className={styles.backButton}
                    onClick={() => {
                        setSelectedBatchRun(undefined);
                        setSelectedSourceSystemKey(null);
                    }}
                >
                    All Batches
                </Breadcrumb.Item>
                {!!sourceSystemName && (
                    <>
                        <ChevronRight size={24} className="breadcrumb-chevron" />
                        <Breadcrumb.Item
                            active={!!sourceSystemName && !batchName}
                            onClick={() => {
                                setSelectedBatchRun(undefined);
                            }}
                        >
                            {sourceSystemName}
                        </Breadcrumb.Item>
                    </>
                )}
                {!!batchName && (
                    <>
                        <ChevronRight size={24} className="breadcrumb-chevron" />
                        <Breadcrumb.Item active={!!batchName}>{batchName}</Breadcrumb.Item>
                    </>
                )}
            </Breadcrumb>
        </div>
    );
};

export default BatchRunBreadCrumb;
